export function formatAccountName(account?: { id: number; name: string }) {
  if (!account) {
    return "N/A";
  }

  return account.name;
}
